/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Lookups_TitleInputs */

const cs_integrations_lookups_title = /** @type {(inputs: Integrations_Lookups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílená vyhledávání`)
};

const en_integrations_lookups_title = /** @type {(inputs: Integrations_Lookups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared lookups`)
};

/**
* | output |
* | --- |
* | "Shared lookups" |
*
* @param {Integrations_Lookups_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_lookups_title = /** @type {((inputs?: Integrations_Lookups_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Lookups_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_lookups_title(inputs)
	return cs_integrations_lookups_title(inputs)
});